import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar } from 'lucide-react';
import TaskCalendar from '../../components/Admin/TaskCalendar';

const AcademicCalendarPage = () => {
    const navigate = useNavigate();

    return (
        <div className="space-y-6">
            {/* Header Section */}
            <div className="border border-gray-100 dark:border-[#1a3884]/20 rounded-[1.25rem] px-6 py-4 shadow-sm flex flex-col md:flex-row md:items-center justify-between gap-4 bg-white dark:bg-[#002147]">
                <div className="flex items-center gap-4">
                    <button
                        onClick={() => navigate('/dashboard')}
                        className="p-2 rounded-xl border border-gray-200 dark:border-[#1a3884]/30 hover:bg-gray-50 dark:hover:bg-[#1a3884]/20 text-gray-500 transition-colors"
                        title="Go back"
                        aria-label="Go back"
                    >
                        <ArrowLeft className="w-5 h-5" />
                    </button>
                    <div className="space-y-0.5 text-left">
                        <h1 className="text-[22px] font-black text-[#1a3884] dark:text-[#4f7dff] tracking-tight">
                            Academic Calendar
                        </h1>
                        <div className="flex items-center gap-1.5 text-[13px] font-medium text-gray-500 dark:text-gray-400">
                            <Calendar className="w-4 h-4 text-[#1a3884]/60 dark:text-[#4f7dff]/60" />
                            Manage academic events, tasks and institutional schedule
                        </div>
                    </div>
                </div>
            </div>

            <TaskCalendar />
        </div>
    );
};

export default AcademicCalendarPage;
